var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{staticClass:"ipv4-input",attrs:{"value":_vm.value,"state":_vm.isFieldInvalid,"formatter":_vm.formatter},on:{"focus":function($event){_vm.inUse = true},"blur":_vm.validateIpv4}})}
var staticRenderFns = []

export { render, staticRenderFns }